import { ADMIN_ACCOUNT_ROUTE, ADMIN_DETAIL, BRANCH_ROUTE, CATEGORY_MERCHANT_ROUTE, COUPON_HISTORY, COUPON_ROUTE, DRIVER_FINANCIAL_CLEARANCE_ROUTE, DRIVER_ROUTE, FORM_DRIVER_REGISTER, HOME_ROUTE, ORDER_ROUTE, PRODUCT_MERCHANT_ROUTE, PROMOTION_ROUTE, RIDER_BALANCE, RIDER_REPORT, SALES_REPORT_ROUTE, STAFF_ROUTE } from '../paths';

export const ADMIN_PERMISSION_ROUTES: string[] = [
    HOME_ROUTE, 
    ORDER_ROUTE, 
    SALES_REPORT_ROUTE,
    RIDER_REPORT,
    COUPON_HISTORY,
    ADMIN_ACCOUNT_ROUTE,
    STAFF_ROUTE,
    BRANCH_ROUTE,
    PRODUCT_MERCHANT_ROUTE,
    CATEGORY_MERCHANT_ROUTE,
    DRIVER_ROUTE,
    FORM_DRIVER_REGISTER,
    RIDER_BALANCE,
    DRIVER_FINANCIAL_CLEARANCE_ROUTE,
    COUPON_ROUTE,
    PROMOTION_ROUTE,
    ADMIN_DETAIL
];
